<template>
  <div class="home" :class="{lan_En : lan != 'zh'}">
    <div class="content content1">
      <div class="cont1">
        <div class="icon1"></div>
        <p class="desc1">DeepLink {{$t('cont1.text1')}}</p>
        <p class="desc2">{{$t('cont1.text2')}}</p>
        <a class="btn" href="https://www.deeplink.cloud/DeeplinkSetup.exe">{{$t('cont1.btn')}}</a>
        <p class="desc3">{{$t('cont1.text3_1')}} <a href="https://t.me/deeplinkglobal">{{$t('cont1.text3_2')}}</a> {{$t('cont1.text3_3')}}</p>
      </div>
    </div>
    <div class="content content2">
      <div class="cont2">
        <div class="icon1"></div>
        <div class="icon2"></div>
        <p class="desc1">{{$t('cont2.text1')}}</p>
        <p class="desc2">{{$t('cont2.text2')}}</p>
        <div class="desc3">
          <p class="tip1">{{$t('cont2.text3')}}</p>
          <p class="tip2">{{$t('cont2.text4')}}</p>
        </div>
        <div class="line"></div>
        <div class="branch"></div>
        <div class="tree" :class="{lan_Ru : lan == 'ru'}">
          <div class="leaf leaf1">
            <div class="line1"></div>
            <img class="icon" src="../assets/leaf_icon1.png" alt="">
            <div class="text">
              <p class="title">{{$t('cont2.leaf1.text1')}} <br> {{$t('cont2.leaf1.text2')}}</p>
              <p>{{$t('cont2.leaf1.text3')}}</p>
              <p>{{$t('cont2.leaf1.text4')}}</p>
            </div>
          </div>
          <div class="leaf">
            <div class="line1"></div>
            <img class="icon" src="../assets/leaf_icon2.png" alt="">
            <div class="text">
              <p class="title">{{$t('cont2.leaf2.text1')}}</p>
              <p>{{$t('cont2.leaf2.text3')}}</p>
            </div>
          </div>
          <div class="leaf">
            <div class="line1"></div>
            <img class="icon" src="../assets/leaf_icon3.png" alt="">
            <div class="text">
              <p class="title">{{$t('cont2.leaf3.text1')}}</p>
              <p>{{$t('cont2.leaf3.text3')}}</p>
            </div>
          </div>
          <div class="leaf leaf2">
            <div class="line1 line2"></div>
            <img class="icon" src="../assets/leaf_icon4.png" alt="">
            <div class="text">
              <p class="title">{{$t('cont2.leaf4.text1')}}</p>
              <p>{{$t('cont2.leaf4.text3')}}</p>
            </div>
          </div>
          <div class="leaf leaf2">
            <div class="line1 line2"></div>
            <img class="icon" src="../assets/leaf_icon5.png" alt="">
            <div class="text">
              <p class="title">{{$t('cont2.leaf5.text1')}}</p>
              <p>{{$t('cont2.leaf5.text3')}}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="content content3">
      <div class="cont3">
        <div class="icon1"></div>
        <p class="desc1">{{$t('cont3.text1')}}</p>
        <p class="desc2">{{$t('cont3.text2')}}</p>
        <div class="video">
          <video :src="videoLink"
            loop="loop" 
            muted="muted" 
            controls="controls"
            controlsList="nodownload, ">
          </video>
        </div>
        <div class="table">
          <div class="li">
            <img class="icon" src="../assets/li_icon1.png" alt="">
            <div class="info">
              <p class="title">{{$t('cont3.li1.text1')}}</p>
              <div class="desc">
                <span>{{$t('cont3.li1.text2')}}</span>
                <span>{{$t('cont3.li1.text3')}}</span>
                <span>{{$t('cont3.li1.text4')}}</span>
              </div>
            </div>
          </div>
          <div class="li">
            <img class="icon" src="../assets/li_icon2.png" alt="">
            <div class="info">
              <p class="title">{{$t('cont3.li2.text1')}}</p>
              <div class="desc">
                <span>{{$t('cont3.li2.text2')}}</span>
                <span>{{$t('cont3.li2.text3')}}</span>
                <span>{{$t('cont3.li2.text4')}}</span>
                <span>{{$t('cont3.li2.text5')}}</span>
              </div>
            </div>
          </div>
          <div class="li">
            <img class="icon" src="../assets/li_icon3.png" alt="">
            <div class="info">
              <p class="title">{{$t('cont3.li3.text1')}}</p>
              <div class="desc">
                <span>{{$t('cont3.li3.text2')}}</span>
                <span>{{$t('cont3.li3.text3')}}</span>
                <span>{{$t('cont3.li3.text4')}}</span>
                <span>{{$t('cont3.li3.text5')}}</span>
                <span>{{$t('cont3.li3.text6')}}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="desc3">{{$t('cont3.desc3')}}</div>
      </div>
    </div>
    <div class="content content4">
      <div class="cont4 hide">
        <div class="icon1"></div>
        <p class="desc1">{{$t('cont4.text1')}}</p>
        <div class="imglist">
          <div class="img_li">
            <img class="img" src="../assets/li_img1.png" alt="">
            <div class="tip">
              <img class="img_4k" src="../assets/li_img4.png" alt="">
              <p>{{$t('cont4.text2')}}</p>
              <img class="group" src="../assets/group1.png" alt="">
            </div>
          </div>
          <div class="img_li">
            <img class="img" src="../assets/li_img2.png" alt="">
            <div class="tip">
              <img class="img_10bit" src="../assets/li_img5.png" alt="">
              <p>{{$t('cont4.text3')}}</p>
              <img class="group" src="../assets/group1.png" alt="">
            </div>
          </div>
          <div class="img_li">
            <img class="img" src="../assets/li_img3.png" alt="">
            <div class="tip">
              <img class="img_block" src="../assets/li_img6.png" alt="">
              <p>{{$t('cont4.text4')}}</p>
              <img class="group" src="../assets/group1.png" alt="">
            </div>
          </div>
        </div>
        <div class="line">
          <img class="group" src="../assets/group3.png" alt="">
          <div class="horizontal"></div>
          <img class="group" src="../assets/group4.png" alt="">
        </div>
        <div class="desc2">
          <div class="tip">{{$t('cont4.text5')}}</div>
          <div class="tip">{{$t('cont4.text6')}}</div>
        </div>
      </div>
      <div class="cont4 show">
        <p class="desc1">{{$t('cont4.text1')}}</p>
        <el-carousel class="imglist" :interval="4000" indicator-position="none" type="card" height="300px">
          <el-carousel-item>
            <div class="img_li">
              <img class="img" src="../assets/li_img1.png" alt="">
              <div class="tip">
                <img class="img_4k" src="../assets/li_img4.png" alt="">
                <p>{{$t('cont4.text2')}}</p>
                <img class="group" src="../assets/group1.png" alt="">
              </div>
            </div>
          </el-carousel-item>
          <el-carousel-item>
            <div class="img_li">
              <img class="img" src="../assets/li_img2.png" alt="">
              <div class="tip">
                <img class="img_10bit" src="../assets/li_img5.png" alt="">
                <p>{{$t('cont4.text3')}}</p>
                <img class="group" src="../assets/group1.png" alt="">
              </div>
            </div>
          </el-carousel-item>
          <el-carousel-item>
            <div class="img_li">
              <img class="img" src="../assets/li_img3.png" alt="">
              <div class="tip">
                <img class="img_block" src="../assets/li_img6.png" alt="">
                <p>{{$t('cont4.text4')}}</p>
                <img class="group" src="../assets/group1.png" alt="">
              </div>
            </div>
          </el-carousel-item>
        </el-carousel>
        <div class="line">
          <img class="group" src="../assets/group3.png" alt="">
          <div class="horizontal"></div>
          <img class="group" src="../assets/group4.png" alt="">
        </div>
        <div class="desc2">
          <div class="tip">{{$t('cont4.text5')}}</div>
          <div class="tip">{{$t('cont4.text6')}}</div>
        </div>
      </div>
    </div>
    <div class="content content5">
      <div class="cont5">
        <div class="icon1"></div>
        <p class="desc1">{{$t('cont5.text1')}}</p>
        <p class="desc2">{{$t('cont5.text2')}}</p>
        <div class="video"><img src="../assets/peripherals.png" alt=""></div>
      </div>
    </div>
    <div class="content content6"> 
      <div class="cont6 hide">
        <div class="icon1"></div>
        <p class="desc1">{{$t('cont6.text1')}}</p>
        <div class="contimg">
          <img src="../assets/cont6.png" alt="">
          <div class="block1">
            <div class="span active">
              <p class="title">{{$t('cont6.block1.title1')}}</p>
              <p>{{$t('cont6.block1.desc1')}}</p>
            </div>
            <div class="span">
              <p class="title">{{$t('cont6.block1.title2')}}</p>
              <p>{{$t('cont6.block1.desc2')}}</p>
            </div>
            <div class="span">
              <p class="title">{{$t('cont6.block1.title3')}}</p>
              <p>{{$t('cont6.block1.desc3')}}</p>
            </div>
            <div class="span">
              <p class="title">{{$t('cont6.block1.title4')}}</p>
              <p>{{$t('cont6.block1.desc4')}}</p>
            </div>
          </div>
          <div class="block2">
            <div class="active">
              <p class="title">{{$t('cont6.block2.title1')}}</p>
              <p>{{$t('cont6.block2.desc1')}}</p>
            </div>
            <div class="span">
              <p class="title">{{$t('cont6.block2.title2')}}</p>
              <p>{{$t('cont6.block2.desc2')}}</p>
            </div>
          </div>
          <div class="block3">
            <div class="span">
              <p class="title">{{$t('cont6.block3.title1')}}</p>
              <p>{{$t('cont6.block3.desc1')}}</p>
            </div>
            <div class="span">
              <p class="title">{{$t('cont6.block3.title2')}}</p>
              <p>{{$t('cont6.block3.desc2')}}</p>
            </div>
            <div class="span">
              <p class="title">{{$t('cont6.block3.title3')}}</p>
              <p>{{$t('cont6.block3.desc3')}}</p>
            </div>
          </div>
        </div> 
        <p class="desc2">{{$t('cont7.text1')}}</p>
        <div class="details">
          <img class="details_bg" src="../assets/contimg1.png" alt="">
          <img class="details_bg" src="../assets/contimg2.png" alt="">
          <div class="detail_con con1">
            <div class="block">
              <div class="li_img">
                <img class="img" src="../assets/demo.png" alt="">
                <p class="word">{{$t('cont7.block1.word1')}}</p>
              </div>
              <div class="li_img">
                <img class="img" src="../assets/demo1.png" alt="">
                <p class="word">{{$t('cont7.block1.word2')}}</p>
              </div>
              <div class="li_img">
                <img class="img" src="../assets/demo2.png" alt="">
                <p class="word">{{$t('cont7.block1.word3')}}</p>
              </div>
              <div class="li_img">
                <img class="img" src="../assets/demo3.png" alt="">
                <p class="word">{{$t('cont7.block1.word4')}}</p>
              </div>
            </div>
            <div class="block text">
              <p class="title">{{$t('cont7.block2.text1')}}</p>
              <p class="text1">{{$t('cont7.block2.text2')}}</p>
              <p class="text1">{{$t('cont7.block2.text3')}}</p>
              <p class="text1">{{$t('cont7.block2.text4')}}</p>
            </div>
          </div>
          <div class="detail_con con2">
            <div class="block text">
              <p class="title">{{$t('cont7.block3.text1')}}</p>
              <p class="text1">{{$t('cont7.block3.text2')}}</p>
              <p class="text1">{{$t('cont7.block3.text3')}}</p>
              <p class="text1">{{$t('cont7.block3.text4')}}</p>
              <p class="text1">{{$t('cont7.block3.text5')}}</p>
            </div>
            <div class="block">
              <div class="li_img">
                <img class="img" src="../assets/demo4.png" alt="">
                <p class="word">{{$t('cont7.block1.word5')}}</p>
              </div>
              <div class="li_img">
                <img class="img" src="../assets/demo5.png" alt="">
                <p class="word">{{$t('cont7.block1.word6')}}</p>
              </div>
              <div class="li_img">
                <img class="img" src="../assets/demo6.png" alt="">
                <p class="word">{{$t('cont7.block1.word7')}}</p>
              </div>
              <div class="li_img">
                <img class="img" src="../assets/demo7.png" alt="">
                <p class="word">{{$t('cont7.block1.word8')}}</p>
              </div>
            </div>
          </div>
        </div> 
      </div>
      <div class="cont7 show">
        <p class="desc1">{{$t('cont6.text1')}}</p>
        <div class="top_con">
          <img src="../assets/mobile/bg5.png" alt="">
          <div class="block">
            <div class="piece">
              <p class="title">{{$t('cont6.block1.title1')}}</p>
              <p>{{$t('cont6.block1.desc1')}}</p>
            </div>
            <div class="piece">
              <p class="title">{{$t('cont6.block1.title2')}}</p>
              <p>{{$t('cont6.block1.desc2')}}</p>
            </div>
            <div class="piece">
              <p class="title">{{$t('cont6.block1.title3')}}</p>
              <p>{{$t('cont6.block1.desc3')}}</p>
            </div>
            <div class="piece">
              <p class="title">{{$t('cont6.block1.title4')}}</p>
              <p>{{$t('cont6.block1.desc4')}}</p>
            </div>
          </div>
        </div>
        <div class="center_con">
          <div class="left">
            <p class="title">{{$t('cont6.block2.title1')}}</p>
            <p>{{$t('cont6.block2.desc1')}}</p>
          </div>
          <div class="right">
            <p class="title">{{$t('cont6.block2.title2')}}</p>
            <p>{{$t('cont6.block2.desc2')}}</p>
          </div>
        </div>
        <div class="down_con">
          <div class="block">
            <div class="piece">
              <p class="title">{{$t('cont6.block3.title1')}}</p>
              <p>{{$t('cont6.block3.desc1')}}</p>
            </div>
            <div class="piece">
              <p class="title">{{$t('cont6.block3.title2')}}</p>
              <p>{{$t('cont6.block3.desc2')}}</p>
            </div>
            <div class="piece">
              <p class="title">{{$t('cont6.block3.title3')}}</p>
              <p>{{$t('cont6.block3.desc3')}}</p>
            </div>
          </div>
          <img src="../assets/mobile/bg6.png" alt="">
        </div>
        <p class="desc2">{{$t('cont7.text1')}}</p>
        <div class="details">
          <div class="detail_con">
            <div class="block">
              <div class="li_img">
                <img class="img" src="../assets/demo.png" alt="">
                <p class="word">{{$t('cont7.block1.word1')}}</p>
              </div>
              <div class="li_img">
                <img class="img" src="../assets/demo1.png" alt="">
                <p class="word">{{$t('cont7.block1.word2')}}</p>
              </div>
              <div class="li_img">
                <img class="img" src="../assets/demo2.png" alt="">
                <p class="word">{{$t('cont7.block1.word3')}}</p>
              </div>
              <div class="li_img">
                <img class="img" src="../assets/demo3.png" alt="">
                <p class="word">{{$t('cont7.block1.word4')}}</p>
              </div>
            </div>
            <div class="block text">
              <p class="title">{{$t('cont7.block2.text1')}}</p>
              <p class="text1">{{$t('cont7.block2.text2')}}</p>
              <p class="text1">{{$t('cont7.block2.text3')}}</p>
              <p class="text1">{{$t('cont7.block2.text4')}}</p>
            </div>
          </div>
          <div class="detail_con">
            <div class="block">
              <div class="li_img">
                <img class="img" src="../assets/demo4.png" alt="">
                <p class="word">{{$t('cont7.block1.word5')}}</p>
              </div>
              <div class="li_img">
                <img class="img" src="../assets/demo5.png" alt="">
                <p class="word">{{$t('cont7.block1.word6')}}</p>
              </div>
              <div class="li_img">
                <img class="img" src="../assets/demo6.png" alt="">
                <p class="word">{{$t('cont7.block1.word7')}}</p>
              </div>
              <div class="li_img">
                <img class="img" src="../assets/demo7.png" alt="">
                <p class="word">{{$t('cont7.block1.word8')}}</p>
              </div>
            </div>
            <div class="block text">
              <p class="title">{{$t('cont7.block3.text1')}}</p>
              <p class="text1">{{$t('cont7.block3.text2')}}</p>
              <p class="text1">{{$t('cont7.block3.text3')}}</p>
              <p class="text1">{{$t('cont7.block3.text4')}}</p>
              <p class="text1">{{$t('cont7.block3.text5')}}</p>
            </div>
          </div>
        </div> 
      </div>
    </div>
  </div>
</template>

<script>
  // @ is an alias to /src
  import { defineComponent, ref, computed, watch } from "vue";
  import { useStore } from "vuex"
  export default defineComponent({
    name: 'Home',
    setup() {
      const store = useStore()
      const obj = {
        'zh': "/deeplink_cn.mp4",
        'ko': "/deeplink_kr.mp4"
      }
      let lan = computed(() => {
        return store.state.lan
      })
      const videoLink = ref(obj[lan.value] ? obj[lan.value] : "deeplink_us.mp4")
      watch(lan, (newvlaue, oldvalue) => {
        videoLink.value = obj[newvlaue] ? obj[newvlaue] : "deeplink_us.mp4"
      })
      return {
        lan,
        videoLink
      };
    }
  })
</script>

<style lang="scss" scoped>
.home {
  width: 100%;
  font-style: normal;
  font-family: 'Rubik, sans-serif';
  .content {
    position: relative;
    min-width: 1200px;
    margin-top: -2px;
    width: 100%;
    font-size: 0;
    line-height: 0;
    &.content1 {
      height: 680px;
      background: url("../assets/img1.png") no-repeat center;
      background-size: 100% 680px;
    }
    &.content2 {
      height: 840px;
      background: url("../assets/img2.png") no-repeat center;
      background-size: 100% 840px;
    }
    &.content3 {
      height: 994px;
      background: url("../assets/img3.png") no-repeat center;
      background-size: 100% 994px;
    }
    &.content4 {
      height: 776px;
      background: url("../assets/img4.png") no-repeat center;
      background-size: 100% 776px;
    }
    &.content5 {
      height: 886px;
      background: url("../assets/img5.png") no-repeat center;
      background-size: 100% 886px;
    }
    &.content6 {
      height: 1544px;
      background: url("../assets/img6.png") no-repeat center;
      background-size: 100% 1544px;
    }
    .cont1 {
      position: relative;
      margin: auto;
      min-width: 1200px;
      max-width: 1440px;
      text-align: center;
      font-weight: 500;
      height: 680px;
      background: url("../assets/img1_bg.png") no-repeat center;
      overflow: hidden;
      // background-size: 100% 658px;
      // background-position: 0px -80px;
      background-position-y: -80px;
      .icon1 {
        position: absolute;
        top: -40px;
        left: 280px;
        width: 112px;
        height: 112px;
        background: url('../assets/icon1.png') no-repeat 100%/100%;
      }
      .icon2 {
        position: absolute;
        top: 0px;
        left: 1000px;
        width: 133px;
        height: 133px;
        background: url('../assets/icon2.png') no-repeat 100%/100%;
        opacity: .8;
      }
      .icon3 {
        position: absolute;
        top: 400px;
        left: 1110px;
        width: 133px;
        height: 133px;
        background: url('../assets/icon3.png') no-repeat 100%/100%;
        opacity: .8;
      }
      p {
        margin-bottom: 10px;
      }
      .desc1 {
        font-size: 28px;
        line-height: 39px;
        color: #363F5E;
        margin: 450px 0 0 0;
      }
      .desc2 {
        font-size: 20px;
        line-height: 28px;
        color: #505887;
      }
      .btn {
        display: block;
        width: 180px;
        height: 50px;
        line-height: 50px;
        text-align: center;
        border-radius: 58px;
        color: #fff;
        margin: 20px auto 10px;
        font-size: 18px;
        background: linear-gradient(271.98deg, #2AB36A 4.13%, rgba(104, 204, 79, 0.8) 114.86%);
        text-decoration: none;
      }
      .desc3 {
        font-weight: 400;
        font-size: 14px;
        line-height: 20px;
        color: rgba(80, 88, 135, 0.6);
      }
    }
    .cont2 {
      position: relative;
      margin: auto;
      min-width: 1200px;
      max-width: 1440px;
      padding-top: 120px;
      text-align: center;
      .icon1 {
        position: absolute;
        top: 10px;
        left: 168px;
        width: 105px;
        height: 105px;
        background: url('../assets/icon4.png') no-repeat 100%/100%;
      }
      .icon2 {
        position: absolute;
        top: 85px;
        left: 950px;
        width: 120px;
        height: 120px;
        background: url('../assets/icon5.png') no-repeat 100%/100%;
      }
      .icon3 {
        position: absolute;
        bottom: -180px;
        right: 210px;
        width: 145px;
        height: 145px;
        background: url('../assets/icon6.png') no-repeat 100%/100%;
      }
      p {
        margin-bottom: 5px;
      }
      .desc1 {
        font-weight: 600;
        font-size: 30px;
        line-height: 42px;
        color: #FFFFFF;
      }
      .desc2 {
        font-weight: 400;
        font-size: 16px;
        line-height: 22px;
        margin-bottom: 20px;
        color: rgba(255, 255, 255, 0.88);
      }
      .desc3 {
        width: 420px;
        height: 120px;
        margin: auto;
        font-weight: 600;
        padding-top: 27px;
        text-align: center;
        box-sizing: border-box;
        background: url(../assets/tree.png) no-repeat 100%/100%;
        .tip1 {
          color: #FFF;
          font-size: 24px;
          line-height: 33px;
        }
        .tip2 {
          font-size: 18px;
          line-height: 25px;
          color: #44FF55;
        }
      }
      .line {
        position: absolute;
        top: 330px;
        left: 0;
        right: 0;
        width: 3px;
        margin: auto;
        height: 102px;
        background: url(../assets/line.png) no-repeat 100%/100%;
      }
      .branch {
        position: relative;
        width: 820px;
        height: 0;
        margin: 50px auto 0;
        border-top: 2px dashed rgba(4, 180, 116, 0.68);
      }
      .tree {
        position: relative;
        width: 1000px;
        display: flex;
        margin: auto;
        justify-content: space-between;
        .leaf {
          width: 180px;
          text-align: center;
          .line1 {
            width: 3px;
            margin: auto;
            height: 51px;
            background: url(../assets/line.png) no-repeat 100%/100%;
          }
          .icon {
            width: 52px;
            height: 52px;
            margin-bottom: 15px;
          }
          .text {
            width: 180px;
            height: 180px;
            padding: 10px;
            font-weight: 400;
            font-size: 12px;
            line-height: 18px;
            text-align: justify;
            border-radius: 12px;
            box-sizing: border-box;
            border: 1px solid rgba(255, 255, 255, 0.45);
            color: rgba(255, 255, 255, 0.6);
            background: linear-gradient(0deg, rgba(255, 255, 255, 0.16) 0%, rgba(255, 255, 255, 0.016) 96.01%);
            .title {
              width: 100%;
              height: 40px;
              font-weight: 600;
              font-size: 16px;
              line-height: 20px;
              text-align: center;
              color: #44FF55;
              margin-bottom: 10px;
            }
          }
        }
        .group {
          position: absolute;
          bottom: -30px;
          width: 58px;
          height: 12px;
        }
        .group1 {
          left: -15px;
        }
        .group2 {
          right: -15px;
        }
      }
    }
    .cont3 {
      position: relative;
      margin: auto;
      min-width: 1200px;
      max-width: 1440px;
      padding-top: 20px;
      text-align: center;
      .icon1 {
        position: absolute;
        top: 460px;
        left: 110px;
        width: 204px;
        height: 204px;
        background: url('../assets/icon7.png') no-repeat 100%/100%;
      }
      p {
        margin-bottom: 10px;
      }
      .desc1 {
        font-weight: 600;
        font-size: 30px;
        line-height: 42px;
        color: #FFFFFF;
      }
      .desc2 {
        width: 722px;
        font-weight: 400;
        font-size: 16px;
        line-height: 26px;
        margin: 0 auto 30px;
        color: rgba(255, 255, 255, 0.88);
      }
      .video {
        width: 820px;
        height: 460px;
        margin: 0 auto 25px;
        video {
          width: 820px;
          height: 460px;
        }
      }
      .table {
        width: 900px;
        height: 140px;
        margin: auto;
        display: flex;
        text-align: center;
        justify-content: space-between;
        .li {
          width: 285px;
          height: 140px;
          padding: 20px 10px;
          border-radius: 12px;
          box-sizing: border-box;
          box-shadow: 0px 6px 24px rgba(54, 63, 94, 0.12);
          background: linear-gradient(180deg, rgba(255, 255, 255, 0.96) 18.59%, rgba(255, 255, 255, 0.576) 100%);
          .icon {
            width: 27px;
            height: 27px;
            margin-bottom: 5px;
          }
          .title {
            font-size: 16px;
            font-weight: 500;
            color: #363F5E;
            line-height: 22px;
            text-align: center;
          }
          .desc {
            width: 100%;
            display: flex;
            flex-wrap: wrap;
            font-size: 12px;
            font-weight: 400;
            line-height: 17px;
            justify-content: space-between;
            color: rgba(80, 88, 135, 0.8);
          }
        }
      }
      .desc3 {
        width: 646px;
        height: 30px;
        font-size: 12px;
        color: #FFFFFF;
        font-weight: 500;
        line-height: 30px;
        text-align: center;
        border-radius: 57px;
        margin: 20px auto 0;
        background: linear-gradient(270deg, rgba(201, 213, 254, 0.24) 0%, rgba(117, 143, 234, 0.578478) 26.14%, rgba(117, 143, 234, 0.6) 76.42%, rgba(201, 213, 254, 0.24) 100%);
      }
    }
    .cont4 {
      position: relative;
      margin: auto;
      min-width: 1200px;
      max-width: 1440px;
      padding-top: 70px;
      text-align: center;
      &.hide {
        display: block;
      }
      &.show {
        display: none;
      }
      .icon1 {
        position: absolute;
        right: 240px;
        bottom: -135px;
        width: 133px;
        height: 133px;
        background: url('../assets/icon8.png') no-repeat 100%/100%;
      }
      p {
        margin-bottom: 10px;
      }
      .desc1 {
        font-weight: 500;
        font-size: 30px;
        line-height: 42px;
        color: #363F5E;
        margin-bottom: 60px;
      }
      .imglist {
        margin: auto;
        width: 1000px;
        display: flex;
        justify-content: space-between;
        .img_li {
          width: 320px;
          .img {
            width: 320px;
            height: 180px;
            margin-bottom: 10px;
          }
          .tip {
            width: 100%;
            display: flex;
            align-items: center;
            .img_4k {
              width: 35px;
              height: 26px;
            }
            .img_10bit {
              width: 59px;
              height: 26px;
            }
            .img_block {
              width: 27px;
              height: 26px;
            }
            .group {
              width: 58px;
              height: 12px;
            }
            p {
              margin: 0 10px;
              font-size: 14px;
              font-weight: 500;
              color: #505887;
              line-height: 20px;
              display: inline-block;
            }
          }
        }
      }
      .line {
        width: 1000px;
        display: flex;
        align-items: center;
        margin: 48px auto 24px;
        justify-content: space-between;
        .group {
          width: 69px;
          height: 12px;
        }
        .horizontal {
          height: 2px;
          width: 820px;
          border-radius: 6px;
          background: linear-gradient(270deg, rgba(4, 180, 116, 0.16) 0%, rgba(4, 180, 116, 0.8) 50.3%, rgba(4, 180, 116, 0.16) 101.67%);

        }
      }
      .desc2 {
        margin: auto;
        display: flex;
        width: 1000px;
        font-size: 14px;
        font-weight: 500;
        line-height: 24px;
        justify-content: space-between;
        color: rgba(80, 88, 135, 0.86);
        .tip {
          width: 490px;
          height: 110px;
          border-radius: 12px;
          text-align: justify;
          padding: 20px 20px 0;
          box-sizing: border-box;
          box-shadow: 0px 6px 20px rgba(54, 63, 94, 0.1);
          background: linear-gradient(180deg, rgba(255, 255, 255, 0.88) 18.59%, rgba(255, 255, 255, 0.528) 100%);
        }
      }
    }
    .cont5 {
      position: relative;
      margin: auto;
      min-width: 1200px;
      max-width: 1440px;
      padding-top: 70px;
      text-align: center;
      .icon1 {
        position: absolute;
        left: 134px;
        bottom: -175px;
        width: 133px;
        height: 133px;
        background: url('../assets/icon9.png') no-repeat 100%/100%;
      }
      p {
        margin-bottom: 10px;
      }
      .desc1 {
        font-weight: 500;
        font-size: 30px;
        line-height: 42px;
        color: #363F5E;
      }
      .desc2 {
        width: 890px;
        font-size: 16px;
        color: #363F5E;
        font-weight: 400;
        line-height: 26px;
        margin: 40px auto 50px;
      }
      .video {
        margin: auto;
        width: 920px; 
        height: 460px;
        img {
          width: 920px;
          height: 460px;
        }
      }
    }
    .cont6 {
      position: relative;
      margin: auto;
      min-width: 1200px;
      max-width: 1440px;
      padding-top: 50px;
      text-align: center;
      &.hide {
        display: block;
      }
      .icon1 {
        position: absolute;
        right: 194px;
        top: 690px;
        width: 133px;
        height: 133px;
        background: url('../assets/icon10.png') no-repeat 100%/100%;
      }
      p {
        margin-bottom: 10px;
      }
      .desc1, .desc2 {
        font-weight: 500;
        font-size: 30px;
        line-height: 42px;
        color: #363F5E;
      }
      .contimg {
        position: relative;
        width: 1000px;
        height: 560px;
        margin: 40px auto 240px;
        img {
          width: 1000px;
          height: 560px;
        }
        .block1 {
          position: absolute;
          right: 90px;
          top: 38px;
          width: 540px;
          height: 138px;
          display: flex;
          align-items: center;
          justify-content: space-between;
          p {
            margin-bottom: 0;
          }
          .span {
            width: 120px;
            height: 138px;
            text-align: center;
            padding: 38px 5px 0;
            box-sizing: border-box;
            font-weight: 400;
            font-size: 12px;
            line-height: 16px;
            color: rgba(80, 88, 135, 0.66);
            .title {
              font-weight: 600;
              font-size: 16px;
              line-height: 22px;
              color: #505887;
              margin-bottom: 5px;
            }
            &.active {
              color: rgba(255, 255, 255, 0.66);
              .title {
                color: #FFFFFF;
              }
            }
          }
        }
        .block2 {
          width: 500px;
          height: 150px;
          position: absolute;
          right: 250px;
          top: 200px;
          display: flex;
          align-items: center;
          justify-content: space-between;
          p {
            margin-bottom: 5px;
          }
          .span {
            width: 250px;
            height: 150px;
            text-align: left;
            padding: 56px 40px 0;
            box-sizing: border-box;
            font-weight: 500;
            font-size: 16px;
            line-height: 22px;
            color: #363F5E;
            .title {
              font-weight: 500;
              font-size: 26px;
              line-height: 36px;
            }
          }
          .active {
            width: 250px;
            height: 150px;
            text-align: right;
            padding: 56px 40px 0;
            box-sizing: border-box;
            font-weight: 500;
            font-size: 16px;
            line-height: 22px;
            color: #fff;
            .title {
              font-weight: 500;
              font-size: 26px;
              line-height: 36px;
            }
          }
        }
        .block3{
          position: absolute;
          left: 88px;
          bottom: 40px;
          width: 392px;
          height: 138px;
          display: flex;
          align-items: center;
          justify-content: space-between;
          p {
            margin-bottom: 0;
          }
          .span {
            width: 120px;
            height: 138px;
            text-align: center;
            padding: 38px 5px 0;
            box-sizing: border-box;
            font-weight: 400;
            font-size: 12px;
            line-height: 16px;
            color: rgba(80, 88, 135, 0.66);
            .title {
              font-weight: 600;
              font-size: 16px;
              line-height: 22px;
              color: #505887;
              margin-bottom: 5px;
            }
          }
        }
      }
      .details {
        position: relative;
        width: 1000px;
        margin: 50px auto 0;
        .details_bg {
          width: 1000px;
          height: 200px;
        }
        .detail_con {
          position: absolute;
          width: 1000px;
          height: 200px;
          display: flex;
          align-items: center;
          justify-content: space-between;
          .block {
            width: 500px;
            height: 200px;
            display: flex;
            padding: 16px 10px 0;
            box-sizing: border-box;
            justify-content: space-between;
            .li_img {
              position: relative;
              width: 114px;
              height: 168px;
              .img {
                width: 114px;
                height: 168px;
              }
              .word {
                width: 100%;
                position: absolute;
                bottom: 0;
                font-weight: 400;
                font-size: 12px;
                line-height: 16px;
                text-align: center;
                letter-spacing: 0.1em;
                color: rgba(255, 255, 255, 0.68);
                text-shadow: 0px 4px 20px rgba(54, 63, 94, 0.5);
              }
            }
            .title {
              font-size: 20px;
              font-weight: 500;
              color: #1F1F1F;
              line-height: 28px;
              text-align: center;
              margin-bottom: 20px;
              text-shadow: 0px 4px 40px rgba(54, 63, 94, 0.24);
            }
            .text1 {
              opacity: 0.8;
              font-weight: 400;
              font-size: 14px;
              line-height: 20px;
              color: #505887;
              margin-bottom: 2px;
            }
            &.text {
              padding: 0;
              flex-direction: column;
              justify-content: center;
            }
          }
        }
        .con1 {
          top: 0;
        }
        .con2 {
          top: 200px;
        }
      }
    }
    .show {
      display: none;
    }
  }
}

.lan_En.home {
  .content {
    // word-break: break-all;
    .cont2 {
      .desc3 {
        width: 480px;
        padding: 25px 5px 0;
        .tip1 {
          font-size: 16px;
          line-height: 24px;
        }
        .tip2 {
          font-size: 12px;
          line-height: 18px;
        }
      }
      .line {
        height: 80px;
      }
      .branch {
        margin: 25px auto 0;
      }
      .tree {
        &.lan_Ru {
          .leaf {
            .text {
              width: 200px;
              height: 240px;
            }
          }
        }
        .leaf {
          .line1 {
            height: 30px;
          }
          .icon {
            margin-bottom: 10px;
          }
          .text {
            height: 210px;
            padding: 10px 5px;
            font-size: 12px;
            line-height: 14px;
            p {
              margin-bottom: 0;
              text-align: left;
            }
            .title {
              font-size: 14px;
              line-height: 16px;
              text-align: center;
              margin-bottom: 10px;
            }
          }
        }
        .group {
          position: absolute;
          bottom: -30px;
          width: 58px;
          height: 12px;
        }
        .group1 {
          left: -15px;
        }
        .group2 {
          right: -15px;
        }
      }
    }
    .cont3 {
      p {
        margin-bottom: 5px;
      }
      .table {
        height: 160px;
        .li {
          height: 160px;
          padding: 10px;
          .title {
            line-height: 18px;
          }
          .desc {
            line-height: 14px;
          }
        }
      }
    }
    .cont4 {
      .desc2 {
        .tip {
          height: 150px;
          padding: 10px 10px 0;
        }
      }
    }
    .cont6 {
      .contimg {
        .block1 {
          .span {
            padding: 25px 5px 0;
            line-height: 14px;
            .title {
              font-size: 14px;
              line-height: 18px;
            }
          }
        }
        .block2 {
          .span {
            padding: 50px 20px 0;
            .title {
              font-size: 22px;
            }
          }
          .active {
            padding: 50px 20px 0;
            .title {
              line-height: 1;
              font-size: 22px;
            }
          }
        }
        .block3{
          .span {
            padding: 30px 5px 0;
            line-height: 14px;
            .title {
              font-size: 14px;
              line-height: 18px;
            }
          }
        }
      }
      .details {
        .detail_con {
          .block {
            .title {
              font-size: 18px;
              line-height: 24px;
            }
            .text1 {
              font-size: 12px;
              line-height: 16px;
            }
            &.text {
              padding: 10px;
            }
          }
        }
      }
    }
  }
}

@media screen and (max-width: 1200px){
  .el-carousel__item {
    display: flex;
    align-items: center;
  }
  .home {
    width: 100%;
    .content {
      position: relative;
      min-width: 600px;
      margin-top: -2px;
      width: 100%;
      font-size: 0;
      line-height: 0;
      &.content1 {
        height: 846px;
        background: url("../assets/mobile/img1.png") no-repeat center;
        background-size: 100% 846px;
      }
      &.content2 {
        height: 1061px;
        background: url("../assets/mobile/img2.png") no-repeat center;
        background-size: 100% 1061px;
      }
      &.content3 {
        height: 1166px;
        background: url("../assets/mobile/img3.png") no-repeat center;
        background-size: 100% 1166px;
      }
      &.content4 {
        height: 882px;
        background: url("../assets/mobile/img4.png") no-repeat center;
        background-size: 100% 882px;
      }
      &.content5 {
        height: 850px;
        background: url("../assets/mobile/img5.png") no-repeat center;
        background-size: 100% 850px;
      }
      &.content6 {
        height: inherit;
        background: #F7F7F9;
      }
      .cont1 {
        position: relative;
        margin: auto;
        min-width: unset;
        // max-width: 1440px;
        width: 100%;
        text-align: center;
        font-weight: 500;
        height: 800px;
        background: url("../assets/mobile/img1_bg.png") no-repeat center;
        overflow: hidden;
        // background-size: 100% 658px;
        background-position-y: 0;
        .icon1 {
          position: absolute;
          top: 70px;
          left: 60px;
          width: 112px;
          height: 112px;
          transform: rotate(40deg);
          background: url('../assets/icon1.png') no-repeat 100%/100%;
        }
        p {
          margin-bottom: 10px;
        }
        .desc1 {
          font-size: 24px;
          font-weight: 600;
          color: #363F5E;
          line-height: 39px;
          margin: 510px auto 0;
          word-break: break-word;
        }
        .desc2 {
          width: 85%;
          margin: auto;
          font-size: 20px;
          line-height: 28px;
          color: #505887;
          word-break: break-word;
        }
        .btn {
          display: block;
          width: 180px;
          height: 50px;
          line-height: 50px;
          text-align: center;
          border-radius: 58px;
          color: #fff;
          margin: 20px auto 10px;
          font-size: 18px;
          background: linear-gradient(271.98deg, #2AB36A 4.13%, rgba(104, 204, 79, 0.8) 114.86%);
          text-decoration: none;
        }
        .desc3 {
          font-weight: 400;
          font-size: 14px;
          line-height: 20px;
          color: rgba(80, 88, 135, 0.6);
        }
      }
      .cont2 {
        position: relative;
        margin: auto;
        min-width: unset;
        padding-top: 40px;
        text-align: center;
        .icon1 {
          position: absolute;
          top: -75px;
          left: 80px;
          width: 105px;
          height: 105px;
          background: url('../assets/icon4.png') no-repeat 100%/100%;
        }
        .icon2 {
          position: absolute;
          top: 0px;
          right: 80px;
          left: unset;
          width: 120px;
          height: 120px;
          background: url('../assets/icon5.png') no-repeat 100%/100%;
        }
        p {
          margin-bottom: 5px;
        }
        .desc1 {
          font-weight: 600;
          font-size: 24px;
          line-height: 42px;
          color: #FFFFFF;
        }
        .desc2 {
          width: 85%;
          font-weight: 400;
          font-size: 16px;
          margin: auto;
          line-height: 22px;
          margin-bottom: 20px;
          color: rgba(255, 255, 255, 0.88);
        }
        .desc3 {
          width: 420px;
          height: 120px;
          margin: auto;
          font-weight: 600;
          padding-top: 27px;
          text-align: center;
          box-sizing: border-box;
          background: url(../assets/tree.png) no-repeat 100%/100%;
          .tip1 {
            color: #FFF;
            font-size: 24px;
            line-height: 33px;
          }
          .tip2 {
            font-size: 18px;
            line-height: 25px;
            color: #44FF55;
          }
        }
        .line {
          position: absolute;
          top: 250px;
          left: 0;
          right: 0;
          width: 3px;
          margin: auto;
          height: 50px;
          background: url(../assets/line.png) no-repeat 100%/100%;
        }
        .branch {
          position: relative;
          width: 64%;
          height: 0;
          margin: 50px auto 0;
          border-top: 2px dashed rgba(4, 180, 116, 0.68);
        }
        .tree {
          position: relative;
          width: 100%;
          display: flex;
          margin: auto;
          flex-wrap: wrap;
          justify-content: center;
          .leaf {
            width: 28%;
            margin: 0 2%;
            text-align: center;
            &.leaf2 {
              margin-top: -300px;
            }
            .line1 {
              width: 3px;
              margin: auto;
              height: 51px;
              background: url(../assets/line.png) no-repeat 100%/100%;
            }
            .line2 {
              height: 330px;
              background-repeat: repeat-y;
            }
            .icon {
              width: 52px;
              height: 52px;
              margin-bottom: 15px;
            }
            .text {
              width: 100%;
              height: 180px;
              padding: 10px;
              font-weight: 400;
              font-size: 12px;
              line-height: 18px;
              text-align: justify;
              border-radius: 12px;
              box-sizing: border-box;
              border: 1px solid rgba(255, 255, 255, 0.45);
              color: rgba(255, 255, 255, 0.6);
              background: linear-gradient(0deg, rgba(255, 255, 255, 0.16) 0%, rgba(255, 255, 255, 0.016) 96.01%);
              .title {
                width: 100%;
                height: 40px;
                font-weight: 600;
                font-size: 16px;
                line-height: 20px;
                text-align: center;
                color: #44FF55;
                margin-bottom: 10px;
              }
            }
          }
        }
      }
      .cont3 {
        position: relative;
        margin: auto;
        min-width: auto;
        max-width: auto;
        padding-top: 100px;
        text-align: center;
        .icon1 {
          display: none;
        }
        p {
          margin-bottom: 10px;
        }
        .desc1 {
          font-weight: 600;
          font-size: 24px;
          line-height: 42px;
          color: #FFFFFF;
        }
        .desc2 {
          width: 85%;
          font-weight: 400;
          font-size: 16px;
          line-height: 26px;
          margin: 0 auto 30px;
          color: rgba(255, 255, 255, 0.88);
        }
        .video {
          width: auto;
          max-width: 640px;
          height: auto;
          margin: 0 auto 50px;
          video {
            width: 100%;
            max-width: 640px;
            height: auto;
          }
        }
        .table {
          width: 80%;
          height: auto;
          margin: auto;
          display: flex;
          flex-wrap: wrap;
          text-align: center;
          justify-content: center;
          .li {
            width: 100%;
            height: auto;
            display: flex;
            padding: 10px 10px;
            align-items: center;
            border-radius: 12px;
            margin-bottom: 20px;
            box-sizing: border-box;
            justify-content: space-between;
            box-shadow: 0px 6px 24px rgba(54, 63, 94, 0.12);
            background: linear-gradient(180deg, rgba(255, 255, 255, 0.96) 18.59%, rgba(255, 255, 255, 0.576) 100%);
            .icon {
              width: 27px;
              height: 27px;
              margin-right: 20px;
              margin-bottom: 5px;
            }
            .info {
              flex: 1;
              .title {
                font-size: 16px;
                font-weight: 500;
                color: #363F5E;
                line-height: 22px;
                text-align: left;
              }
              .desc {
                width: 100%;
                display: flex;
                font-size: 12px;
                font-weight: 400;
                line-height: 17px;
                justify-content: start;
                color: rgba(80, 88, 135, 0.8);
                span {
                  margin-right: 20px;
                }
              }
            }
          }
        }
        .desc3 {
          width: 600px;
          height: 30px;
          font-size: 12px;
          color: #FFFFFF;
          font-weight: 500;
          line-height: 30px;
          text-align: center;
          border-radius: 57px;
          margin: 20px auto 0;
          background: linear-gradient(270deg, rgba(201, 213, 254, 0.24) 0%, rgba(117, 143, 234, 0.578478) 26.14%, rgba(117, 143, 234, 0.6) 76.42%, rgba(201, 213, 254, 0.24) 100%);
        }
      }
      .cont4 {
        position: relative;
        margin: auto;
        min-width: auto;
        max-width: auto;
        padding-top: 60px;
        text-align: center;
        &.hide {
          display: none;
        }
        &.show {
          display: block;
        }
        p {
          margin-bottom: 10px;
        }
        .desc1 {
          font-weight: 500;
          font-size: 24px;
          line-height: 42px;
          color: #363F5E;
          margin-bottom: 10px;
        }
        .imglist {
          width: 90%;
          max-width: 900px;
          margin: auto;
          display: block;
          .img_li {
            width: 100%;
            .img {
              width: 100%;
              height: auto;
              margin-bottom: 10px;
            }
            .tip {
              width: 100%;
              display: flex;
              align-items: center;
              justify-content: center;
              .img_4k {
                width: 35px;
                height: 26px;
              }
              .img_10bit {
                width: 59px;
                height: 26px;
              }
              .img_block {
                width: 27px;
                height: 26px;
              }
              .group {
                width: 58px;
                height: 12px;
              }
              p {
                margin: 0 10px;
                font-size: 14px;
                font-weight: 500;
                color: #505887;
                line-height: 20px;
                display: inline-block;
              }
            }
          }
        }
        .line {
          width: 90%;
          display: flex;
          align-items: center;
          margin: 0 auto 24px;
          justify-content: space-between;
          .group {
            width: 69px;
            height: 12px;
          }
          .horizontal {
            height: 2px;
            width: 60%;
            border-radius: 6px;
            background: linear-gradient(270deg, rgba(4, 180, 116, 0.16) 0%, rgba(4, 180, 116, 0.8) 50.3%, rgba(4, 180, 116, 0.16) 101.67%);

          }
        }
        .desc2 {
          width: 90%;
          margin: auto;
          display: flex;
          flex-wrap: wrap;
          font-size: 14px;
          font-weight: 500;
          line-height: 24px;
          justify-content: space-between;
          color: rgba(80, 88, 135, 0.86);
          .tip {
            width: 100%;
            height: auto;
            margin-bottom: 10px;
            border-radius: 12px;
            text-align: justify;
            padding: 20px;
            box-sizing: border-box;
            box-shadow: 0px 6px 20px rgba(54, 63, 94, 0.1);
            background: linear-gradient(180deg, rgba(255, 255, 255, 0.88) 18.59%, rgba(255, 255, 255, 0.528) 100%);
          }
        }
      }
      .cont5 {
        position: relative;
        margin: auto;
        min-width: unset;
        max-width: unset;
        padding-top: 50px;
        text-align: center;
        .icon1 {
         display: none;
        }
        p {
          margin-bottom: 10px;
        }
        .desc1 {
          font-weight: 500;
          font-size: 24px;
          line-height: 42px;
          color: #363F5E;
        }
        .desc2 {
          width: 85%;
          font-size: 16px;
          color: #363F5E;
          font-weight: 400;
          line-height: 26px;
          margin: 40px auto 50px;
        }
        .video {
          margin: auto;
          width: 90%; 
          height: auto;
          img {
            width: 100%;
            height: auto;
          }
        }
      }
      .cont6 {
        position: relative;
        margin: auto;
        min-width: 1200px;
        max-width: 1440px;
        padding-top: 50px;
        text-align: center;
        &.hide {
          display: none;
        }
        .icon1 {
          position: absolute;
          right: 194px;
          top: 690px;
          width: 133px;
          height: 133px;
          background: url('../assets/icon10.png') no-repeat 100%/100%;
        }
        p {
          margin-bottom: 10px;
        }
        .desc1, .desc2 {
          font-weight: 500;
          font-size: 30px;
          line-height: 42px;
          color: #363F5E;
        }
        .contimg {
          position: relative;
          width: 1000px;
          height: 560px;
          margin: 40px auto 240px;
          img {
            width: 1000px;
            height: 560px;
          }
          .block1 {
            position: absolute;
            right: 90px;
            top: 38px;
            width: 540px;
            height: 138px;
            display: flex;
            align-items: center;
            justify-content: space-between;
            p {
              margin-bottom: 0;
            }
            .span {
              width: 120px;
              height: 138px;
              text-align: center;
              padding: 38px 5px 0;
              box-sizing: border-box;
              font-weight: 400;
              font-size: 12px;
              line-height: 16px;
              color: rgba(80, 88, 135, 0.66);
              .title {
                font-weight: 600;
                font-size: 16px;
                line-height: 22px;
                color: #505887;
                margin-bottom: 5px;
              }
              &.active {
                color: rgba(255, 255, 255, 0.66);
                .title {
                  color: #FFFFFF;
                }
              }
            }
          }
          .block2 {
            width: 500px;
            height: 150px;
            position: absolute;
            right: 250px;
            top: 200px;
            display: flex;
            align-items: center;
            justify-content: space-between;
            p {
              margin-bottom: 5px;
            }
            .span {
              width: 250px;
              height: 150px;
              text-align: left;
              padding: 56px 40px 0;
              box-sizing: border-box;
              font-weight: 500;
              font-size: 16px;
              line-height: 22px;
              color: #363F5E;
              .title {
                font-weight: 500;
                font-size: 26px;
                line-height: 36px;
              }
            }
            .active {
              width: 250px;
              height: 150px;
              text-align: right;
              padding: 56px 40px 0;
              box-sizing: border-box;
              font-weight: 500;
              font-size: 16px;
              line-height: 22px;
              color: #fff;
              .title {
                font-weight: 500;
                font-size: 26px;
                line-height: 36px;
              }
            }
          }
          .block3{
            position: absolute;
            left: 88px;
            bottom: 40px;
            width: 392px;
            height: 138px;
            display: flex;
            align-items: center;
            justify-content: space-between;
            p {
              margin-bottom: 0;
            }
            .span {
              width: 120px;
              height: 138px;
              text-align: center;
              padding: 38px 5px 0;
              box-sizing: border-box;
              font-weight: 400;
              font-size: 12px;
              line-height: 16px;
              color: rgba(80, 88, 135, 0.66);
              .title {
                font-weight: 600;
                font-size: 16px;
                line-height: 22px;
                color: #505887;
                margin-bottom: 5px;
              }
            }
          }
        }
        .details {
          position: relative;
          width: 1000px;
          margin: 50px auto 0;
          .details_bg {
            width: 1000px;
            height: 200px;
          }
          .detail_con {
            position: absolute;
            width: 1000px;
            height: 200px;
            display: flex;
            align-items: center;
            justify-content: space-between;
            .block {
              width: 500px;
              height: 200px;
              display: flex;
              padding: 16px 10px 0;
              box-sizing: border-box;
              justify-content: space-between;
              .li_img {
                position: relative;
                width: 114px;
                height: 168px;
                .img {
                  width: 114px;
                  height: 168px;
                }
                .word {
                  width: 100%;
                  position: absolute;
                  bottom: 0;
                  font-weight: 400;
                  font-size: 12px;
                  line-height: 16px;
                  text-align: center;
                  letter-spacing: 0.1em;
                  color: rgba(255, 255, 255, 0.68);
                  text-shadow: 0px 4px 20px rgba(54, 63, 94, 0.5);
                }
              }
              .title {
                font-size: 20px;
                font-weight: 500;
                color: #1F1F1F;
                line-height: 28px;
                text-align: center;
                margin-bottom: 20px;
                text-shadow: 0px 4px 40px rgba(54, 63, 94, 0.24);
              }
              .text1 {
                opacity: 0.8;
                font-weight: 400;
                font-size: 14px;
                line-height: 20px;
                color: #505887;
                margin-bottom: 2px;
              }
              &.text {
                padding: 0;
                flex-direction: column;
                justify-content: center;
              }
            }
          }
          .con1 {
            top: 0;
          }
          .con2 {
            top: 200px;
          }
        }
      }
      .show {
        display: block;
      }
      .cont7 {
        position: relative;
        margin: auto;
        padding-top: 30px;
        text-align: center;
        .desc1, .desc2 {
          font-weight: 500;
          font-size: 24px;
          line-height: 42px;
          color: #363F5E;
          margin-bottom: 40px;
        }
        .top_con {
          width: 90%;
          margin: auto;
          img {
            width: 90%;
            max-width: 600px;
            min-width: 400px;
          }
          .block {
            width: 100%;
            display: flex;
            margin-top: -80px;
            align-items: center;
            justify-content: space-between;
            .piece {
              width: 158px;
              height: 179px;
              display: flex;
              padding: 0 5px;
              font-size: 12px;
              font-weight: 400;
              line-height: 16px;
              flex-direction: column;
              box-sizing: border-box;
              justify-content: center;
              color: rgba(255, 255, 255, 0.8);
              background: url(../assets/mobile/bg4.png) no-repeat 100%/100%;
              .title {
                font-weight: 600;
                font-size: 16px;
                line-height: 22px;
                color: #fff;
                margin-bottom: 5px;
              }
            }
          }
        }
        .center_con {
          width: 592px;
          height: 129px;
          font-size: 12px;
          margin: 40px auto;
          display: flex;
          align-items: center;
          justify-content: center;
          background: url(../assets/mobile/bg7.png) no-repeat 100%/100%;
          .left,.right {
            width: 33%;
            padding: 0 10px;
            line-height: 22px;
          }
          .left {
            color: #FFF;
            text-align: right;
          }
          .right {
            color: #363F5E;
            text-align: left;
          }
          .title {
            font-size: 20px;
            line-height: 30px;
          }
        }
        .down_con {
          width: 80%;
          margin: 0 auto 200px;
          img {
            width: 90%;
            max-width: 600px;
            min-width: 400px;
            margin-top: -80px;
          }
          .block {
            position: relative;
            z-index: 1;
            width: 100%;
            display: flex;
            align-items: center;
            justify-content: space-between;
            .piece {
              width: 158px;
              height: 179px;
              display: flex;
              padding: 0 5px;
              font-size: 12px;
              font-weight: 400;
              line-height: 16px;
              flex-direction: column;
              box-sizing: border-box;
              justify-content: center;
              color: rgba(54, 63, 94, 0.8);
              background: url(../assets/mobile/bg3.png) no-repeat 100%/100%;
              .title {
                font-size: 16px;
                color: #363F5E;
                font-weight: 600;
                line-height: 22px;
                margin-bottom: 5px;
              }
            }
          }
        }
        .details {
          width: 90%;
          margin: auto;
          max-width: 750px;
          padding-bottom: 20px;
          .detail_con {
            width: 100%;
            margin-bottom: 20px;
            .block {
              width: 100%;
              max-height: 300px;
              display: flex;
              padding: 24px 15px;
              background: #505887;
              box-sizing: border-box;
              border-radius: 10px 10px 0 0;
              justify-content: space-between;
              .li_img {
                flex: 1;
                position: relative;
                max-width: 171px;
                max-height: 252px;
                margin-right: 10px;
                &:last-child {
                  margin-right: 0;
                }
                .img {
                  width: 100%;
                  // max-width: 171px;
                }
                .word {
                  width: 100%;
                  position: absolute;
                  bottom: 10px;
                  font-weight: 400;
                  font-size: 12px;
                  line-height: 16px;
                  text-align: center;
                  letter-spacing: 0.1em;
                  color: rgba(255, 255, 255, 0.68);
                  text-shadow: 0px 4px 20px rgba(54, 63, 94, 0.5);
                }
              }
              .title {
                font-size: 20px;
                font-weight: 500;
                color: #363F5E;
                line-height: 28px;
                text-align: center;
                margin-bottom: 20px;
                text-shadow: 0px 4px 40px rgba(54, 63, 94, 0.24);
              }
              .text1 {
                opacity: 0.8;
                font-weight: 400;
                font-size: 14px;
                line-height: 20px;
                margin-bottom: 2px;
                color: rgba(54, 63, 94, 0.8);
              }
              &.text {
                position: relative;
                padding: 30px;
                border-radius: 0;
                background: #fff;
                flex-direction: column;
                justify-content: center;
                &::before {
                  position: absolute;
                  content: '';
                  top: -10px;
                  right: calc(50% - 10px);
                  border-left: 10px solid transparent;
                  border-right: 10px solid transparent;
                  border-bottom: 10px solid #fff;
                }
              }
            }
          }
        }
      }
    }
  }
  .lan_En.home {
    .content {
      // word-break: break-all;
      .cont1 {
        .desc1 {
          width: 95%;
          line-height: 1;
          margin-bottom: 10px;
        }
      }
      .cont2 {
        .tree {
          &.lan_Ru {
            .leaf {
              .text {
                width: 100%;
                height: inherit;
              }
            }
          }
          .leaf {
            &.leaf2 {
              margin-top: -290px;
            }
            .line2 {
              height: 330px;
            }
            .text {
              width: 100%;
              min-height: 200px;
              height: inherit;
            }
          }
        }
      }
      .cont3 {
        .desc2 {
          margin-bottom: 30px;
        }
        .table {
          height: auto;
          .li {
            height: auto;
            padding: 10px 10px;
          }
        }
      }
      .cont4 {
        .desc2 {
          .tip {
            height: auto;
            padding: 20px;
          }
        }
      }
    }
  }
}
</style>
